// extracted by mini-css-extract-plugin
export default {"share":"LearnerResultShare_share__Yhz7X","social":"LearnerResultShare_social__zVSds","copy":"LearnerResultShare_copy__o19OC","check":"LearnerResultShare_check__m1WoV"};